import type { AuthenticatedSession } from '@kiku/auth/types';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

export function useSentryUser(session: AuthenticatedSession | undefined): void {
  useEffect(() => {
    if (session) {
      // Email intentionally omitted — consistent with beforeSend PII scrubbing (GDPR)
      Sentry.setUser({ id: session.userId });
    }
    return () => {
      Sentry.setUser(null);
    };
  }, [session]);
}
